/// <amd-module name="Wit/BoardsHub/KanbanBoard/Components/CardMenuButton" />

import * as React from "react";
import { IReadonlyObservableArray } from "VSS/Core/Observable";
import { IMenuItem, MenuButton } from "VSSUI/Menu";
import * as Resources from "Wit/BoardsHub/KanbanBoard/Resources";
import { format } from "VSS/Core/Util/String";

export const CardMenuButton = React.forwardRef<
    MenuButton,
    {
        className?: string;
        menuItems: IReadonlyObservableArray<IMenuItem>;
        onExpand?: () => void;
        onCollapse?: () => void;
        ariaHidden?: boolean;
        workItemTitle?: string;
    }
>(({ className, menuItems, onExpand, onCollapse, ariaHidden, workItemTitle }, ref): JSX.Element => {
    const ariaLabel = workItemTitle ?
        format(Resources.MenuButtonAriaLabelWithTitle, Resources.MenuButtonAriaLabel, workItemTitle) :
        Resources.MenuButtonAriaLabel;

    return (
        <MenuButton
            ariaLabel={ariaLabel}
            ariaHidden={ariaHidden}
            buttonClassName="flex-grow"
            className={className}
            hideDropdownIcon={true}
            iconProps={{ className: "small", iconName: "More" }}
            onExpand={onExpand}
            onCollapse={onCollapse}
            contextualMenuProps={{
                menuProps: {
                    id: "card-context-menu",
                    items: menuItems
                }
            }}
            ref={ref}
            subtle
        />
    );
});
